const it = {
    common: {
        history: "versione storica"
    }
};
export default it;



// WEBPACK FOOTER //
// ./src/i18n/langs/it.js